/* unplugin-vue-components disabled */import { render } from "./refundInfo.vue?vue&type=template&id=3ca7f1d3&scoped=true"
import script from "./refundInfo.vue?vue&type=script&lang=js"
export * from "./refundInfo.vue?vue&type=script&lang=js"

import "./refundInfo.vue?vue&type=style&index=0&id=3ca7f1d3&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca7f1d3"]])

export default __exports__